import { KYMW0900Model } from '../kymw0900.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 *アイテムコード一覧取得サービス
 *
 * @export GetPlanGoodsMaintainService
 * @class GetPlanGoodsMaintainService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPlanGoodsMaintainService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW0C00Model}
   * @memberof GetPlanGoodsMaintainService
   */

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof GetPlanGoodsMaintainService
   */
  private successFunc: Function;

  kymw0900Model: KYMW0900Model = new KYMW0900Model;

  vo = {
    pcode: '',
    orderCode: '',
    mediumType: '',
  };

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPlanGoodsMaintainService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.vo.pcode,
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof GetPlanGoodsMaintainService
   */
  execute(model: KYMW0900Model, vo: any, successFunc: Function = null): void {
    this.kymw0900Model = model;
    this.vo.pcode = vo.pCode;
    this.vo.mediumType = vo.mediumType;
    this.vo.orderCode = vo.orderCode;
    this.successFunc = successFunc;
    this.send('getPlanGoodsMaintain', this.getBody());
  }


  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPlanGoodsMaintainService
   */
  success(data: any): void {
    if (data !== null) {
      this.kymw0900Model.setINITScreen(data);
      // コールバック
      this.successFunc();
    }
  }
}
